import { Button } from "@material-ui/core"
import { useSelector, useDispatch } from "react-redux"
import BackDrop from "../../../global/BackDrop"
import { useState } from "react"
import { obtneerReporteReferenciasAllAction } from "../../../ducks/clientesDuck"
import { ToastMessage } from "../../../global/ToastMessage";
import { catRoles } from "../../../constant/catRoles"
import { usePermiso } from "../../../hooks/usePermiso"
const BotonReporte = () => {
    const { profile } = useSelector(store => store.logeo)
    const [permitido] = usePermiso({ location: "FK_AdministrarClientes_Reportes", initialValue: false })
    const [load, setLoad] = useState(false)
    const dispatch = useDispatch()
    const handleDowload = () => {
        setLoad(true)
        dispatch(obtneerReporteReferenciasAllAction()).then((Response) => {
            const downloadUrl = window.URL.createObjectURL(new Blob([Response.data], { type: "application/vnd.ms-excel" }));
            const link = document.createElement('a');
            link.href = downloadUrl;
            let fchAct = new Date().toISOString();
            let fileName = 'Paquetes-' + fchAct + '.xlsx';
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            ToastMessage.fire({
                icon: "success",
                title: "¡OPERACIÓN EXITOSA!",
            });
            setLoad(false)
        });

    }
    if (profile.Rol?.Id === catRoles.ADMINISTRADOR || permitido) return (
        <div>
            <Button onClick={handleDowload} variant="contained" color="primary">Descargar reporte clientes</Button>
            <BackDrop open={load} />
        </div>
    )
    return null
}
export default BotonReporte